import { __decorate, __metadata } from "tslib";
import { Component, Inject, Model, Prop, Watch } from "vue-property-decorator";
import { SYM_LV_FORM_ITEM } from "../form-item/LvFormItem.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvCheckbox";
/**
 * A checkbox component
 */
let LvCheckbox = class LvCheckbox extends UIComponent {
    constructor() {
        super(...arguments);
        this.checkedDisplayState = false;
    }
    onModelChange(newValue, oldValue) {
        if (newValue == oldValue)
            return;
        this.checkedDisplayState = newValue === this.checkedValue;
    }
    get targetModelProperty() {
        return this.formItem?.prop;
    }
    onCheckboxDisplayStateChange() {
        if (this.checkedDisplayState) {
            this.emitChange(this.checkedValue);
            this.emitChecked();
        }
        else {
            this.emitChange(this.uncheckedValue);
            this.emitUnchecked();
        }
    }
    emitChecked() {
        /**
         * When the checkbox is checked
         */
        this.$emit("checked");
    }
    emitUnchecked() {
        /**
         * When the checkbox is unchecked
         */
        this.$emit("unchecked");
    }
    emitChange(value) {
        /**
         * When the checkbox is checked or uncheked.
         * <br>The new value is given as first argument.
         */
        this.$emit("change", value);
    }
};
__decorate([
    Inject({ default: null, from: SYM_LV_FORM_ITEM }),
    __metadata("design:type", Object)
], LvCheckbox.prototype, "formItem", void 0);
__decorate([
    Prop({ required: false, default: true }),
    __metadata("design:type", Object)
], LvCheckbox.prototype, "checkedValue", void 0);
__decorate([
    Prop({ required: false, default: false }),
    __metadata("design:type", Object)
], LvCheckbox.prototype, "uncheckedValue", void 0);
__decorate([
    Model("change"),
    __metadata("design:type", Object)
], LvCheckbox.prototype, "model", void 0);
__decorate([
    Watch("model", { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], LvCheckbox.prototype, "onModelChange", null);
LvCheckbox = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvCheckbox);
export default LvCheckbox;
//# sourceMappingURL=script.js.map